import { useAuth } from "../../contexts/AuthContext";
import { supabase } from "../auth/supabaseClient";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function NavButton(props) {
  let focusClass = `w-full inline-flex block px-4 py-2 mt-2 text-sm font-semibold text-gray-900 bg-gray-200 rounded-lg dark-mode:bg-gray-700 dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline`;
  let nonFocusClass = `w-full inline-flex items-center block px-4 py-2 mt-2 text-sm font-semibold text-gray-900 bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline`;

  const navigate = useNavigate();

  return (
    <button
      onClick={(e) => {
        navigate(props.path);
      }}
    >
      <div className={`${props.tour_classname}`}>
        <a
          className={
            window.location.pathname == props.path ? focusClass : nonFocusClass
          }
          // href={props.path}
          name={props.name}
        >
          {props.text}
        </a>
      </div>
    </button>
  );
}

function GroupNavButtons(props) {
  const [isTeamAdmin, setIsTeamAdmin] = useState(true);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      getTeamAdminStatus();
    }
  }, [user]);

  const getTeamAdminStatus = async () => {
    setLoading(true);
    let { data, error } = await supabase
      .from("team_membership")
      .select("*")
      .eq("user_id", user.id)
      .eq("role", "admin");

    if (error) {
      console.log(error);
    }

    if (data.length > 0) {
      setIsTeamAdmin(true);
    } else {
      setIsTeamAdmin(false);
    }
    setLoading(false);
  };

  return (
    <div
      className="grid grid-cols-1 content-start"
      hidden={props.hideNavButtons}
    >
      <NavButton
        tour_classname={"tour-mint"}
        path={"/mint"}
        name={"award"}
        text={"Create Award"}
        changeMainAppFocus={props.changeMainAppFocus}
      />

      <NavButton
        tour_classname={"tour-awards"}
        path={"/feed"}
        name={"feed"}
        text={"Latest Awards"}
        changeMainAppFocus={props.changeMainAppFocus}
      />

      {isTeamAdmin && !loading && (
        <NavButton
          path={"/team"}
          name={"team"}
          text={"Team Admin"}
          changeMainAppFocus={props.changeMainAppFocus}
        />
      )}

      <NavButton
        tour_classname={"tour-configure"}
        path={"/set-profile"}
        name={"settings"}
        text={"Settings"}
        changeMainAppFocus={props.changeMainAppFocus}
      />

      <NavButton
        tour_classname={"tour-support"}
        path={"/support"}
        name={"support"}
        text={"Support"}
        changeMainAppFocus={props.changeMainAppFocus}
      />
    </div>
  );
}

function ProfileWidget() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profileImageUrl, setProfileImageUrl] = useState(
    "https://t3.ftcdn.net/jpg/02/33/46/24/360_F_233462402_Fx1yke4ng4GA8TJikJZoiATrkncvW6Ib.jpg"
  );
  const [emailDisplay, setEmailDisplay] = useState("");

  useEffect(() => {
    if (user) {
      getProfile();
      if (user.email) {
        // truncate email
        let email = user.email;
        let emailSplit = email.split("@");
        let emailDisplay =
          emailSplit[0].substring(0, 5) + "...@" + emailSplit[1];
        setEmailDisplay(emailDisplay);
      }
    }
  }, [user]);

  useEffect(() => {
    if (profile) {
      downloadProfileImage();
    }
  }, [profile]);

  const getProfile = async () => {
    if (user) {
      let { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", await user.id)
        .single();
      if (error) {
        console.log(error);
      } else {
        setProfile(data);
      }
    }
  };

  const downloadProfileImage = async () => {
    try {
      const { data, error } = await supabase.storage
        .from("avatars")
        .download(profile.photo_url);
      if (error) {
        throw error;
      }
      const url = URL.createObjectURL(data);
      setProfileImageUrl(url);
    } catch (error) {
      console.log("Error downloading image: ", error.message);
    }
  };

  if (profile) {
    return (
      <button
        onClick={() => {
          navigate("/p/" + profile.username);
        }}
      >
        <div className="flex flex-col items-center justify-center mt-4 mb-4">
          <div className="flex items-center">
            <img
              className="object-cover w-10 h-10 mx-2 rounded-full"
              src={profileImageUrl}
              alt="avatar"
            />
            <h1 className="mx-2 text-gray-600 dark-mode:text-gray-200">
              {profile.first_name}
            </h1>
          </div>
          <p className="mx-4 mt-1 text-xs text-gray-500 dark-mode:text-gray-400">
            {emailDisplay}
          </p>
        </div>
      </button>
    );
  } else {
    return (
      <div className="flex flex-col items-center justify-center mt-8">
        <div className="flex items-center">
          <img
            className="object-cover w-10 h-10 mx-4 rounded-full"
            src="https://t3.ftcdn.net/jpg/02/33/46/24/360_F_233462402_Fx1yke4ng4GA8TJikJZoiATrkncvW6Ib.jpg"
            alt="avatar"
          />
          <h1 className="mx-4 text-gray-600 dark-mode:text-gray-200">
            {user.displayName}
          </h1>
        </div>
        <p className="mx-4 mt-1 text-sm text-gray-500 dark-mode:text-gray-400">
          {emailDisplay}
        </p>
      </div>
    );
  }
}

function SideNavigationBar(props) {
  const { signOut } = useAuth();

  return (
    <aside className="flex flex-col w-full md:w-40 text-gray-700 bg-white dark-mode:text-gray-200 dark-mode:bg-gray-800 flex-shrink-0">
      <div className="flex-shrink-0 px-8 py-4 flex flex-row items-center justify-between">
        <a
          href="#"
          className="text-lg font-semibold tracking-widest text-gray-900 uppercase rounded-lg dark-mode:text-white focus:outline-none focus:shadow-outline"
        >
          RIBBON
        </a>
      </div>
      <ProfileWidget />
      <nav className="tour-nav flex-grow px-4 pb-4 md:block md:pb-0 md:overflow-y-auto">
        <GroupNavButtons
          hideNavButtons={props.hideNavButtons}
          changeMainAppFocus={props.changeMainAppFocus}
        />
        <button
          onClick={signOut}
          className="block px-4 py-2 mt-2 text-sm font-semibold text-gray-400 bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
        >
          Sign Out
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-3 w-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
        </button>
      </nav>
    </aside>
  );
}

export default SideNavigationBar;
